module.exports = __webpack_public_path__ + "static/media/career-cover-Desktop.b65705eb.png";